import React, { FC } from 'react';
import useIsSurveyTemplatesPage from '@hooks/useIsSurveyTemplatesPage';
import {
  DEFAULT_PAGE_SIZE,
  SURVEY_TABLE_SKELETON_DEFAULT_PAGE_SIZE,
} from '@src/utils/constants';

interface TableSkeletonProps {
  columns?: number;
  height?: string;
  rows?: number;
  dataTestId?: string;
  noHorizontalPadding?: boolean;
}

const TableSkeleton: FC<TableSkeletonProps> = ({
  columns = 8,
  height,
  rows,
  dataTestId,
  noHorizontalPadding = false,
}) => {
  const isSurveyTemplate = useIsSurveyTemplatesPage();
  const rowCount = rows
    ? rows
    : isSurveyTemplate
      ? SURVEY_TABLE_SKELETON_DEFAULT_PAGE_SIZE
      : DEFAULT_PAGE_SIZE;

  const containerHeight = height
    ? height
    : isSurveyTemplate
      ? 'calc(100vh - 166px)'
      : '100%';

  return (
    <div className="table-skeleton-container" data-test-id={dataTestId}>
      <div
        className={`table-skeleton${noHorizontalPadding ? ' table-skeleton--no-horizontal-padding' : ''}`}
      >
        <div className="table-head">
          {Array.from({ length: columns }).map((_, index) => (
            <div key={index} className="table-cell">
              <div className="skeleton skeleton-text" />
            </div>
          ))}
        </div>

        <div className="table-body">
          {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <div key={rowIndex} className="table-row">
              {Array.from({ length: columns }).map((_, colIndex) => (
                <div key={colIndex} className="table-cell">
                  <div className="skeleton skeleton-rect" />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TableSkeleton;
